import {
    GivelifyModal,
    GivelifyIcon,
    GivelifyLabel,
} from '@givelify/givelify-ui';
import { styled } from '@mui/material/styles';

export const StyledModal = styled(GivelifyModal)({
    textAlign: 'center',
});

export const StyledIcon = styled(GivelifyIcon)({
    fontSize: 106,
    margin: '0 auto',
});

export const StyledText1 = styled(GivelifyLabel)({
    marginTop: 17,
});

export const StyledText2 = styled(GivelifyLabel)({
    marginBottom: 17,
});
